import { useLanguage } from "./LanguageContext";
import SmoothScrollLink from "./SmoothScrollLink"; // <-- Importato per risolvere il salto su iOS
import "./AboutSection.css";

const AboutSection = () => {
  const { t } = useLanguage();
  const stickyHeaderHeight = 70;

  return (
    <section id="aboutsection" className="bg-light py-5">
      <div className="container">
        <div className="row align-items-center">
          {/* Video a sinistra */}
          <div className="col-lg-6 d-flex justify-content-center mb-4 mb-lg-0">
            <video
              src="https://res.cloudinary.com/dtem45qog/video/upload/v1748508959/8dd2faad-e213-4b75-b21d-fb7917353a22_dpkvzx.mov"
              autoPlay
              muted
              loop
              playsInline /* <-- FONDAMENTALE PER IOS: Impedisce l'apertura a tutto schermo */
              style={{ pointerEvents: "none" }} /* <-- Impedisce all'utente di cliccare o mettere in pausa */
              className="about-video"
            />
          </div>

          {/* Testo a destra */}
          <div className="col-lg-6">
            <h2 className="display-6 fw-bold mb-3">{t("aboutTitle")}</h2>
            <ul className="list-unstyled about-list">
              {t("aboutList").map((item, idx) => (
                <li key={idx}>{item}</li>
              ))}
            </ul>
            <div className="mt-4">
              {/* Sostituito il div manuale con SmoothScrollLink, esattamente come nella Navbar */}
              <SmoothScrollLink
                to="ContactDirect"
                offset={stickyHeaderHeight}
                className="flash-btn d-inline-block"
                style={{ textDecoration: "none" }}
              >
                {t("aboutButton")}
              </SmoothScrollLink>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;